module.exports = __webpack_public_path__ + "assets_app/img/key-1.1606712b.svg";